import { useQuery } from '@apollo/client';
import { GetImpactByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

type Props = {
  impactId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ impactId }) => {
  if (!impactId) {
    throw new Error('Missing impactId param');
  }
  const { data } = useQuery(GetImpactByIdDocument, {
    variables: {
      id: impactId,
    },
  });

  return <>{data?.impact?.[0]?.Name || ''}</>;
};

export default Breadcrumb;
